import { render, staticRenderFns } from "./ContactsPage.vue?vue&type=template&id=24827a12&scoped=true&lang=pug&"
import script from "./ContactsPage.vue?vue&type=script&lang=js&"
export * from "./ContactsPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactsPage.vue?vue&type=style&index=0&id=24827a12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24827a12",
  null
  
)

export default component.exports